import { usePermissions } from '@contexts/permissions-provider';
import { AppLoader } from '@shared/components/app-loader/AppLoader';
import { InlineFeedback } from '@shared/components/inline-feedback/InlineFeedback';
import { useFlags } from 'launchdarkly-react-client-sdk';
import * as React from 'react';
import { Navigate } from 'react-router-dom';

import { resolveInstructLandingRoute } from './InstructRedirectPage.utils';

const InstructRedirectPage = React.memo((): React.ReactElement => {
  const { hasPermission, isLoading } = usePermissions();
  const flags = useFlags();

  if (isLoading) return <AppLoader />;

  const route = resolveInstructLandingRoute({ hasPermission, flags });

  if (route) return <Navigate to={route} replace />;

  return <InlineFeedback type="forbidden" />;
});

InstructRedirectPage.displayName = 'InstructRedirectPage';

export { InstructRedirectPage };
